/** Etiquetas de rol solo para UI (el valor enviado al API sigue siendo el código, ej. SECRETARIA). */

export const USER_ROLE_DISPLAY_LABELS: Record<string, string> = {
  ADMIN: 'Administrador',
  SECRETARIA: 'Secretario/a',
  COORDINADORA: 'Coordinadora',
  GESTOR: 'Gestor',
  GERENTE: 'Gerente',
};

export const USER_ROLE_SELECT_OPTIONS: { value: string; label: string }[] = [
  { value: 'ADMIN', label: USER_ROLE_DISPLAY_LABELS.ADMIN },
  { value: 'SECRETARIA', label: USER_ROLE_DISPLAY_LABELS.SECRETARIA },
  { value: 'COORDINADORA', label: USER_ROLE_DISPLAY_LABELS.COORDINADORA },
  { value: 'GESTOR', label: USER_ROLE_DISPLAY_LABELS.GESTOR },
  { value: 'GERENTE', label: USER_ROLE_DISPLAY_LABELS.GERENTE },
];

export function userRoleDisplayLabel(role: string | undefined | null): string {
  if (!role) return '—';
  return USER_ROLE_DISPLAY_LABELS[role] ?? role;
}
